module.exports = __webpack_public_path__ + "img/stock4.4c6de186.png";